module.exports = __webpack_public_path__ + "static/img/simpleui_projector_lx_up.2864725.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/simple/simpleui_projector_lx_up.png
// module id = Tz/O
// module chunks = 3